/**
 * Created by alex on 01/03/2025.
 * Description:
 * AppendEntityConfirmDialogOptions model
 * ------ maintenance history ------
 */

export class AppendEntityFailedNote {
    id: string;
    subject: string;
    reason?: string;

    constructor(id: string, subject: string, reason?: string) {
        this.id = id;
        this.subject = subject;
        this.reason = reason;
    }
}
